import React from "react";

export const SystemSearchIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7C3 4.79086 4.79086 3 7 3C9.20914 3 11 4.79086 11 7C11 8.10184 10.5558 9.09802 9.83436 9.82248C9.10893 10.5509 8.10785 11 7 11C4.79086 11 3 9.20914 3 7ZM7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C8.29541 13 9.49589 12.5887 10.4764 11.8907L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L11.8907 10.4764C12.5887 9.49589 13 8.29539 13 7C13 3.68629 10.3137 1 7 1Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemInfoIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C9.38474 13 10.6364 12.4384 11.5429 11.5281C12.4445 10.6228 13 9.37723 13 8C13 5.23858 10.7614 3 8 3ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 9.92743 14.2197 11.6745 12.9601 12.9394C11.6937 14.2111 9.93801 15 8 15C4.13401 15 1 11.866 1 8ZM8 7C8.55228 7 9 7.44772 9 8V11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11V8C7 7.44772 7.44772 7 8 7ZM8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemArrowDownIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7L8 11L4 7"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemArrowUpIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 10L8 6L12 10"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemArrowLeftIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12L5 8L9 4"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemArrowRightIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4L11 8L7 12"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemDoubleArrowLeftIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 4.70711C8.09763 4.31658 8.09763 3.68342 7.70711 3.29289C7.31658 2.90237 6.68342 2.90237 6.29289 3.29289L2.29289 7.29289C1.90237 7.68342 1.90237 8.31658 2.29289 8.70711L6.29289 12.7071C6.68342 13.0976 7.31658 13.0976 7.70711 12.7071C8.09763 12.3166 8.09763 11.6834 7.70711 11.2929L4.41421 8L7.70711 4.70711ZM13.7071 4.70711C14.0976 4.31658 14.0976 3.68342 13.7071 3.29289C13.3166 2.90237 12.6834 2.90237 12.2929 3.29289L8.29289 7.29289C7.90237 7.68342 7.90237 8.31658 8.29289 8.70711L12.2929 12.7071C12.6834 13.0976 13.3166 13.0976 13.7071 12.7071C14.0976 12.3166 14.0976 11.6834 13.7071 11.2929L10.4142 8L13.7071 4.70711Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemDoubleArrowRightIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071C2.68342 13.0976 3.31658 13.0976 3.70711 12.7071L7.70711 8.70711C8.09763 8.31658 8.09763 7.68342 7.70711 7.29289L3.70711 3.29289C3.31658 2.90237 2.68342 2.90237 2.29289 3.29289C1.90237 3.68342 1.90237 4.31658 2.29289 4.70711L5.58579 8L2.29289 11.2929ZM8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289L9.70711 3.29289C9.31658 2.90237 8.68342 2.90237 8.29289 3.29289C7.90237 3.68342 7.90237 4.31658 8.29289 4.70711L11.5858 8L8.29289 11.2929Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemCalendarIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C6 1.44772 5.55228 1 5 1C4.44772 1 4 1.44772 4 2V3C2.34315 3 1 4.34315 1 6V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V6C15 4.34315 13.6569 3 12 3V2C12 1.44772 11.5523 1 11 1C10.4477 1 10 1.44772 10 2V3H6V2ZM3 6C3 5.44772 3.44772 5 4 5V6C4 6.55228 4.44772 7 5 7C5.55228 7 6 6.55228 6 6V5H10V6C10 6.55228 10.4477 7 11 7C11.5523 7 12 6.55228 12 6V5C12.5523 5 13 5.44772 13 6V12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12V6ZM11 11C11.5523 11 12 10.5523 12 10C12 9.44771 11.5523 9 11 9C10.4477 9 10 9.44771 10 10C10 10.5523 10.4477 11 11 11ZM6 10C6 10.5523 5.55228 11 5 11C4.44772 11 4 10.5523 4 10C4 9.44771 4.44772 9 5 9C5.55228 9 6 9.44771 6 10ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44771 8.55228 9 8 9C7.44772 9 7 9.44771 7 10C7 10.5523 7.44772 11 8 11Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemDeleteIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1C5.44772 1 5 1.44772 5 2V3H3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5H3.1048C3.1049 5.06573 3.10822 5.13212 3.11491 5.19901L3.82486 12.2985C3.97822 13.8321 5.26872 15 6.80998 15H9.19002C10.7313 15 12.0218 13.8321 12.1751 12.2985L12.8851 5.19901C12.8918 5.13212 12.8951 5.06573 12.8952 5H13C13.5523 5 14 4.55228 14 4C14 3.44772 13.5523 3 13 3H11V2C11 1.44772 10.5523 1 10 1H6ZM5.10499 5H10.895L10.1851 12.0995C10.1339 12.6107 9.70378 13 9.19002 13H6.80998C6.29622 13 5.86606 12.6107 5.81494 12.0995L5.10499 5Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemEditIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 3.5L3 10L2 14L6 13L12.5 6.5M9.5 3.5L10.5858 2.41421C11.3668 1.63317 12.6332 1.63317 13.4142 2.41421L13.5858 2.58579C14.3668 3.36684 14.3668 4.63316 13.5858 5.41421L12.5 6.5M9.5 3.5L12.5 6.5"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemCloseIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 3L3 13M3 3L13 13"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SystemArchieveIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4C1 2.89543 1.89543 2 3 2H13C14.1046 2 15 2.89543 15 4V6C15 6.55228 14.5523 7 14 7V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V7C1.44772 7 1 6.55228 1 6V4ZM4 7H12V13H4V7ZM13 5H3V4H13V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9C9.55229 11 10 10.5523 10 10C10 9.44772 9.55229 9 9 9H7Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemFiltersIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H2L6 6V12L10 14V6L14 2Z"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemLockIcon16 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C6.34315 2 5 3.34315 5 5V6C3.34315 6 2 7.34315 2 9V11C2 12.6569 3.34315 14 5 14H11C12.6569 14 14 12.6569 14 11V9C14 7.34315 12.6569 6 11 6V5C11 3.34315 9.65685 2 8 2ZM9 6V5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V6H9ZM5 8C4.44772 8 4 8.44772 4 9V11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11V9C12 8.44772 11.5523 8 11 8H10H6H5Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemCheckIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13.5714L10.75 17L17 9"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemAlertIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM12 6C11.4477 6 11 6.44772 11 7V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V7C13 6.44772 12.5523 6 12 6Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemCheckCircledIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.8137 9.58124C17.1347 9.13183 17.0307 8.50728 16.5812 8.18627C16.1318 7.86526 15.5073 7.96935 15.1863 8.41876L10.8724 14.4582L8.70711 12.2929C8.31658 11.9024 7.68342 11.9024 7.29289 12.2929C6.90237 12.6834 6.90237 13.3166 7.29289 13.7071L10.2929 16.7071C10.5007 16.915 10.7895 17.0208 11.0825 16.9966C11.3754 16.9723 11.6429 16.8204 11.8137 16.5812L16.8137 9.58124Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemPlusIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V20M4 12H20"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SystemCalendarIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10C7.55228 10 8 10.4477 8 11Z"
        fill="#BCC3CC"
      />
      <path
        d="M8 16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15C7.55228 15 8 15.4477 8 16Z"
        fill="#BCC3CC"
      />
      <path
        d="M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z"
        fill="#BCC3CC"
      />
      <path
        d="M13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z"
        fill="#BCC3CC"
      />
      <path
        d="M17 12C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11C16 11.5523 16.4477 12 17 12Z"
        fill="#BCC3CC"
      />
      <path
        d="M18 16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16C16 15.4477 16.4477 15 17 15C17.5523 15 18 15.4477 18 16Z"
        fill="#BCC3CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8 1.44772 7.55228 1 7 1C6.44772 1 6 1.44772 6 2V3H5C3.34315 3 2 4.34315 2 6V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V6C22 4.34315 20.6569 3 19 3H18V2C18 1.44772 17.5523 1 17 1C16.4477 1 16 1.44772 16 2V3H8V2ZM5 5H6V6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6V5H16V6C16 6.55228 16.4477 7 17 7C17.5523 7 18 6.55228 18 6V5H19C19.5523 5 20 5.44772 20 6V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V6C4 5.44772 4.44772 5 5 5Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemArrowDownIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 9L12 15L6 9"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemArrowUpIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15L12 9L6 15"
        stroke="#BCC3CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SystemMapPinIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9C17 9.6013 16.7064 10.5974 16.147 11.8707C15.6056 13.103 14.876 14.4635 14.135 15.7409C13.3959 17.015 12.6554 18.1894 12.0988 19.0463L12 19.1982L11.9012 19.0463C11.3446 18.1894 10.6041 17.015 9.865 15.7409C9.124 14.4635 8.39441 13.103 7.85304 11.8707C7.29363 10.5974 7 9.6013 7 9ZM11.177 21.5681C11.1771 21.5682 11.1772 21.5683 12 21L11.1772 21.5683C11.3639 21.8386 11.6715 22 12 22C12.3285 22 12.6361 21.8386 12.8228 21.5683L12 21C12.8228 21.5683 12.8229 21.5682 12.823 21.5681L12.8233 21.5677L12.8243 21.5662L12.8279 21.5609L12.8416 21.541L12.8935 21.4651C12.9386 21.399 13.0043 21.3022 13.0877 21.1783C13.2543 20.9305 13.4916 20.5737 13.7762 20.1357C14.3446 19.2603 15.1041 18.0561 15.865 16.7444C16.624 15.436 17.3944 14.0036 17.978 12.6752C18.5436 11.3878 19 10.0555 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 10.0555 5.45637 11.3878 6.02196 12.6752C6.60559 14.0036 7.376 15.436 8.135 16.7444C8.89591 18.0561 9.65537 19.2603 10.2238 20.1357C10.5084 20.5737 10.7457 20.9305 10.9123 21.1783C10.9957 21.3022 11.0614 21.399 11.1065 21.4651L11.1584 21.541L11.1721 21.5609L11.1757 21.5662L11.1767 21.5677L11.177 21.5681ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9ZM12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemMapPinIcon32 = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 11.1C7 6.082 11.0371 2 16 2C20.9629 2 25 6.082 25 11.1C25 16.7371 18.8603 24.5913 16.723 27.1546C16.3409 27.613 15.6591 27.613 15.277 27.1546C13.1397 24.5913 7 16.7371 7 11.1ZM16 14C17.6569 14 19 12.6569 19 11C19 9.34315 17.6569 8 16 8C14.3431 8 13 9.34315 13 11C13 12.6569 14.3431 14 16 14Z"
        fill="#5095EB"
      />
    </svg>
  );
};

export const SystemPhoneIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C12 1.44772 12.4477 1 13 1C18.5228 1 23 5.47715 23 11C23 11.5523 22.5523 12 22 12C21.4477 12 21 11.5523 21 11C21 6.58172 17.4183 3 13 3C12.4477 3 12 2.55228 12 2ZM12 6C12 5.44772 12.4477 5 13 5C16.3137 5 19 7.68629 19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11C17 8.79086 15.2091 7 13 7C12.4477 7 12 6.55228 12 6ZM5.16662 5.28544C5.54721 4.90485 6.16426 4.90485 6.54484 5.28544L7.94106 6.68165C8.32164 7.06224 8.32164 7.67929 7.94106 8.05987L7.74819 8.25275C7.02182 8.97911 6.64617 10.1372 7.15223 11.2247C7.50377 11.9802 8.09831 13.0021 9.04811 13.9519C9.99791 14.9017 11.0198 15.4962 11.7753 15.8478C12.8628 16.3538 14.0209 15.9782 14.7473 15.2518L14.0402 14.5447L14.7473 15.2518L14.9401 15.059C15.3207 14.6784 15.9378 14.6784 16.3184 15.059L17.7146 16.4552C18.0952 16.8358 18.0952 17.4528 17.7146 17.8334L16.7273 18.8206C15.3565 20.1915 13.4078 20.3912 12.0342 19.2874C10.8776 18.358 9.41181 17.072 7.66989 15.3301C5.92798 13.5882 4.64205 12.1224 3.7126 10.9658C2.60878 9.59218 2.80854 7.64353 4.17937 6.27269L5.16662 5.28544ZM7.95906 3.87122C6.79742 2.70959 4.91404 2.70959 3.75241 3.87123L2.76516 4.85848C0.800757 6.82288 0.302845 9.91551 2.1536 12.2186C3.13047 13.4342 4.46506 14.9537 6.25568 16.7443C8.04629 18.5349 9.56581 19.8695 10.7814 20.8464C13.0845 22.6972 16.1771 22.1993 18.1415 20.2349L19.1288 19.2476C20.2904 18.086 20.2904 16.2026 19.1288 15.041L17.7326 13.6447C16.5709 12.4831 14.6876 12.4831 13.5259 13.6447L13.333 13.8376C13.0744 14.0963 12.7946 14.1161 12.6191 14.0345C12.0124 13.7522 11.2037 13.2791 10.4623 12.5377C9.7209 11.7963 9.24784 10.9876 8.96552 10.3809C8.88387 10.2055 8.90373 9.92563 9.1624 9.66696L9.35527 9.47409C10.5169 8.31245 10.5169 6.42907 9.35527 5.26744L7.95906 3.87122Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};

export const SystemWebsiteIcon24 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="#BCC3CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25953 8.25953C8.41837 7.16763 8.64584 6.17227 8.93 5.31981C9.22085 4.44724 9.58923 3.66896 10.0469 3.08829C10.4956 2.51889 11.1481 2 12 2C12.8519 2 13.5044 2.51889 13.9531 3.08829C14.4108 3.66896 14.7791 4.44724 15.07 5.31981C15.3542 6.17227 15.5816 7.16763 15.7405 8.25953C16.8324 8.41837 17.8277 8.64584 18.6802 8.93C19.5528 9.22085 20.331 9.58923 20.9117 10.0469C21.4811 10.4956 22 11.1481 22 12C22 12.8519 21.4811 13.5044 20.9117 13.9531C20.331 14.4108 19.5528 14.7791 18.6802 15.07C17.8277 15.3542 16.8324 15.5816 15.7405 15.7405C15.5816 16.8324 15.3542 17.8277 15.07 18.6802C14.7791 19.5528 14.4108 20.331 13.9531 20.9117C13.5044 21.4811 12.8519 22 12 22C11.1481 22 10.4956 21.4811 10.0469 20.9117C9.58923 20.331 9.22085 19.5528 8.93 18.6802C8.64584 17.8277 8.41837 16.8324 8.25953 15.7405C7.16763 15.5816 6.17227 15.3542 5.31981 15.07C4.44724 14.7791 3.66896 14.4108 3.08829 13.9531C2.51889 13.5044 2 12.8519 2 12C2 11.1481 2.51889 10.4956 3.08829 10.0469C3.66896 9.58923 4.44724 9.22085 5.31981 8.93C6.17227 8.64584 7.16763 8.41837 8.25953 8.25953ZM10.3175 8.05043C10.4526 7.26392 10.6259 6.55656 10.8274 5.95227C11.0794 5.19616 11.3575 4.65642 11.6177 4.32624C11.7455 4.16408 11.8494 4.07752 11.9186 4.03507C11.9515 4.01483 11.9736 4.00645 11.9847 4.00305C11.9948 3.99998 11.9991 4 12 4C12.0009 4 12.0052 3.99998 12.0153 4.00305C12.0264 4.00645 12.0485 4.01483 12.0814 4.03507C12.1506 4.07752 12.2545 4.16408 12.3823 4.32624C12.6425 4.65642 12.9206 5.19616 13.1726 5.95227C13.3741 6.55656 13.5474 7.26393 13.6825 8.05043C13.1347 8.0172 12.5724 8 12 8C11.4276 8 10.8653 8.0172 10.3175 8.05043ZM8.05043 13.6825C7.26392 13.5474 6.55656 13.3741 5.95227 13.1726C5.19616 12.9206 4.65642 12.6425 4.32624 12.3823C4.16408 12.2545 4.07752 12.1506 4.03507 12.0814C4.01483 12.0485 4.00645 12.0264 4.00305 12.0153C3.99998 12.0052 4 12.0009 4 12C4 11.9991 3.99998 11.9948 4.00305 11.9847C4.00645 11.9736 4.01483 11.9515 4.03507 11.9186C4.07752 11.8494 4.16408 11.7455 4.32624 11.6177C4.65642 11.3575 5.19616 11.0794 5.95227 10.8274C6.55656 10.6259 7.26392 10.4526 8.05043 10.3175C8.0172 10.8653 8 11.4276 8 12C8 12.5724 8.0172 13.1347 8.05043 13.6825ZM10.0718 13.9282C10.025 13.3113 10 12.6659 10 12C10 11.3341 10.025 10.6887 10.0718 10.0718C10.6887 10.025 11.3341 10 12 10C12.6659 10 13.3113 10.025 13.9282 10.0718C13.975 10.6887 14 11.3341 14 12C14 12.6659 13.975 13.3113 13.9282 13.9282C13.3113 13.975 12.6659 14 12 14C11.3341 14 10.6887 13.975 10.0718 13.9282ZM10.3175 15.9496C10.4526 16.7361 10.6259 17.4434 10.8274 18.0477C11.0794 18.8038 11.3575 19.3436 11.6177 19.6738C11.7455 19.8359 11.8494 19.9225 11.9186 19.9649C11.9515 19.9852 11.9736 19.9935 11.9847 19.9969C11.9948 20 11.9991 20 12 20C12.0009 20 12.0052 20 12.0153 19.9969C12.0264 19.9935 12.0485 19.9852 12.0814 19.9649C12.1506 19.9225 12.2545 19.8359 12.3823 19.6738C12.6425 19.3436 12.9206 18.8038 13.1726 18.0477C13.3741 17.4434 13.5474 16.7361 13.6825 15.9496C13.1347 15.9828 12.5724 16 12 16C11.4276 16 10.8653 15.9828 10.3175 15.9496ZM15.9496 13.6825C16.7361 13.5474 17.4434 13.3741 18.0477 13.1726C18.8038 12.9206 19.3436 12.6425 19.6738 12.3823C19.8359 12.2545 19.9225 12.1506 19.9649 12.0814C19.9852 12.0485 19.9935 12.0264 19.9969 12.0153C20 12.0052 20 12.0009 20 12C20 11.9993 20.0001 11.9951 19.9969 11.9847C19.9935 11.9736 19.9852 11.9515 19.9649 11.9186C19.9225 11.8494 19.8359 11.7455 19.6738 11.6177C19.3436 11.3575 18.8038 11.0794 18.0477 10.8274C17.4434 10.6259 16.7361 10.4526 15.9496 10.3175C15.9828 10.8653 16 11.4276 16 12C16 12.5724 15.9828 13.1347 15.9496 13.6825Z"
        fill="#BCC3CC"
      />
    </svg>
  );
};
